import { SvgIcon, SvgIconProps } from '@mui/material';

export function TemplateIcon(props: SvgIconProps) {
    return (
        <SvgIcon {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 3H8.33767C7.53383 3 6.76362 3.32259 6.19971 3.89545L5.26211 4.84793L6.67637 6.26218L7.62501 5.29848C7.81298 5.10753 8.06972 5 8.33767 5H11V3ZM11 11H7.625V14L9.625 14V13H11V11ZM13 13V11H16.375V14L14.375 14V13H13ZM9.625 16L7.625 16V18.9999H4V15L2 15V18.9999C2 20.1045 2.89543 20.9999 4 20.9999H7.625C8.72957 20.9999 9.625 20.1045 9.625 18.9999V16ZM2 13L4 13V9.39064C4 9.12815 4.10321 8.87619 4.28735 8.68913L5.27329 7.68753L3.85903 6.27328L2.86204 7.28609C2.30962 7.84728 2 8.60318 2 9.39064V13ZM14.375 16L16.375 16V18.9999H20V15H22V18.9999C22 20.1045 21.1046 20.9999 20 20.9999H16.375C15.2704 20.9999 14.375 20.1045 14.375 18.9999V16ZM22 13V9.39064C22 8.60318 21.6904 7.84728 21.138 7.28609L20.18 6.31289L18.7657 7.72715L19.7127 8.68913C19.8968 8.87619 20 9.12815 20 9.39064V13H22ZM17.3626 6.3018L16.375 5.29848C16.187 5.10753 15.9303 5 15.6623 5H13V3H15.6623C16.4662 3 17.2364 3.32259 17.8003 3.89545L18.7769 4.88754L17.3626 6.3018Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
}
